import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../app.service';
import { Location} from '@angular/common';
@Component({
  selector: 'app-finalapprover',
  templateUrl: './finalapprover.component.html',
  styleUrls: ['./finalapprover.component.scss']
})
export class FinalapproverComponent implements OnInit {
FinalapproverForm!: FormGroup;
  checkerData: any = {};
  constructor(private fb: FormBuilder,private location:Location,private router: Router,private toastr: ToastrService,public appservice:AppService) { }
onApprove() {
    //console.log('Approved:', this.checkerForm.value);
   // this.router.navigate(['/accountcreation']);
   this.appservice.Editfinalapproverdata.OD_iid=this.checkerData.OD_iid;
    this.appservice.Editfinalapproverdata.command= this.checkerData.command;
    this.appservice.Editfinalapproverdata.createdby=this.appservice.username;
    this.appservice.postTable("api/Transaction/Update_Finalapprovalstatus",this.appservice.Editfinalapproverdata).subscribe((res:any)=>{
      if(res=="True"){
 this.toastr.success("Approved successfully!");
this.appservice.FinalApproverdatafetch();
this.appservice.goback();
      }
    });
    
  }
employeeList:any=[];
getemployeeid(){
  this.appservice.getTable("Api/Transaction/GetEmployeeid").subscribe((res:any)=>{
    this.employeeList=JSON.parse(res);
    console.log("the values",this.checkerData.employeeid);
  })
}
  back(){
    this.location.back();
  }
  onDecline() {
    //console.log('the values',this.appservice.FinalApproverdata);
      this.appservice.Editfinalapproverdata.command= this.checkerData.command;
          this.appservice.Editfinalapproverdata.createdby=this.appservice.username;

    this.appservice.postTable("api/Transaction/Update_Finalapprovalstatus",this.appservice.Editfinalapproverdata).subscribe((res:any)=>{
      if(res=="True"){
 this.toastr.success("Rejected successfully!");
this.appservice.FinalApproverdatafetch();
this.appservice.goback();
      }
    });
    
  }
  public rectange:any={};
 Onselectempolyee(data) {
  this.appservice.getTable("Api/Transaction/Getempdetails?empid=" + data).subscribe((res: any) => {
    this.rectange = this.appservice.getJsondata(res);//JSON.parse(res);

    if (this.rectange && this.rectange.length > 0) {
      let emp = this.rectange[0]; // Get first record safely

      // Log first character of first name (if needed)
      console.log("the values", emp.OD_First_name?.[0]);

      // Bind data to checkerData
      this.checkerData.OD_iid =emp.OD_iid;
      this.checkerData.OD_EmployeeID  = emp.OD_EmployeeID;
      this.checkerData.firstName     = emp.OD_First_name;
      this.checkerData.lastName      = emp.OD_Last_Name;
      this.checkerData.designation   = emp.OD_Designation;
      this.checkerData.grade         = emp.OD_Grad;
      this.checkerData.dateOfJoining = emp.OD_Dateofjoin;
      this.checkerData.plant         = emp.OD_Plant;
      this.checkerData.department    = emp.OD_Department;
      this.checkerData.requester     = emp.OD_OnboardingCreatedby;
      this.checkerData.OD_Account_type = emp.OD_Account_type;
        this.checkerData.Furtherdepartment = emp.OD_Changing_Department
    } else {
      console.log('the res is ',res)
      console.warn("No employee data found for ID:", data);
    }
  });
}

  ngOnInit(): void {
  //   this.checkerData = {
  //   employeeId: '12345',
  //   firstName: 'Nareshkumar',
  //   lastName: 'Nagesh',
  //   designation: 'Assistant General Manager',
  //   grade: '4A',
  //   dateOfJoining: '03 Feb 2025',
  //   plant: 'General',
  //   department: 'Information Technology',
  //   requester: 'Sankar Ganesh'

  // };
  //this.getemployeeid();
  this.Onselectempolyee(this.appservice.FinalApproverdata.employeecode); 
}

  

  }


